<template>
  <div class="app-body" ref="body">
    <app-header is-left @click-left="goBack">
      <div slot="title">{{ list.length ? list[0].catename : '' }}</div>
    </app-header>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="padding-top:46px; padding-bottom:5rem;">
      <van-list
        v-model="isLoading"
        :finished="finished"
        :finished-text="finishedtext"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
        class="items"
      >
        <div v-for="item in list" :key="item.id" class="items-item" @click="toDetail(item)">
          <van-cell-group>
            <van-cell class="items-detail">
              <div class="items-li">
                <van-image
                  fit="cover"
                  lazy-load
                  :src="rootPath + item.pic"
                />
                <div class="items-infos">
                  <div class="items-title">{{ item.title }}</div>
                  <div class="items-times">{{ formatDate(item.uptime, 'yyyy-MM-dd HH:mm') }}</div>
                  <!-- <div class="goods-tags">
                    <van-tag v-for="(tag, ii) in (item.tags ? item.tags.split(',') : [])" :key="ii" type="primary" plain>{{ tag }}</van-tag>
                  </div> -->
                  <div class="items-prices">
                    <!-- <div class="items-price"><small>¥</small> {{ item.price }}
                      <div v-if="item.market" class="items-market"><small>¥</small> {{ item.market }}</div>
                    </div> -->
                    <div></div>
                    <van-tag :type="item.isup ? 'danger' : 'default'">{{item.isup ? '报名中' : '未开始'}}</van-tag>
                  </div>
                </div>
              </div>
            </van-cell>
          </van-cell-group>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import AppHeader from '../app-header.vue';
import AppFooter from '../app-footer.vue';
export default {
  components: {
    AppHeader, AppFooter
  },
  mixins: [tools],
  props: ['id'],
  data() {
    return {
      isLoading: false,
      finished: false,
      count: 0,
      page: 1,
      list: [],
      error: false,
      w: 0,
    }
  },
  computed: {
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.638) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {}
      if (this.w) {
        style = {height: (this.w * 0.618 * 0.20) + 'px'};
      }
      return style;
    },
  },
  watch: {
    id() {
      this.loadData();
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });
  },
  mounted () {
    this.page = 1;
  },
  activated() {
    if (!this.list || !this.list.length) {
      // this.loadData();
    }
    if (!this.w) {
      this.getImgW();
    }
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'vue/home/list',
        data: {pageCurrent: this.page, cateid: this.id},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.list = json.list;
            this.page = json.pageNumber;
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    goBack() {
      this.$router.push('/');
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
    formatPrice(price) {
      return '' + (price);
    },
    onClickCart() {
      this.$router.push('cart');
    },
    sorry() {
      Toast('暂无后续逻辑~');
    },
    toDetail(item) {
      this.$router.push('/detail-s/'+ item.id);
    },
    onRefresh() {
      this.isLoading = false;
      this.page = 1;
      this.loadData((json) => {
        this.list = json.list;
        this.page = json.pageNumber;
        this.$toast('刷新成功');
      });
    },
    onLoad() {
      // console.log('load.....')
      this.isLoading = false;
      this.finished = false;
      this.page = this.list.length ? this.page + 1 : 1;
      this.loadData((json) => {
        this.list = this.list.concat(json.list);
        this.page = json.pageNumber;

        // 如果已加载完
        if (!json.totalRow || json.totalPage <= json.pageNumber) {
          this.finished = true;
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.app-body{margin-top:0; margin-bottom:50px; background-color:#fff;}
.items {
  min-height:calc(100vh - 46px - 50px);
  &-cate {
    padding:1rem 1rem;
    background-color:#fff;
    h3 {
      margin:0;
      font-size:1.2rem;
    }
    &-title {
      .flex-center-v();
      justify-content:space-between;
      a {
        font-size:.9rem;
        color:#999;
      }
    }
  }
  &-item {
    position:relative;
    margin-top:0rem;
    padding:1rem;
    background-color:#fff;
    border-bottom:1px #f0f0f0 solid;
    border-radius:0rem;
    .shadow_black(0 0 1px 0);
    .van-cell:not(:last-child)::after{
      left:0;
    }
    .van-hairline--top-bottom::after{
      border-width:0;
    }
    &:first-child {
      margin-top:0;
    }
    &:last-child {
      border-bottom:none;
    }
  }
  &-detail {
    &.van-cell {
      padding-left:0rem;
      padding-right:0rem;
    }
  }
  &-tags {
    .van-tag {
      margin-right:.5rem;
    }
  }
  &-li {
    .flex();
    align-items:stretch;
    .van-image {
      flex-shrink:0;
      width:120px;
      height:80px;
      overflow:hidden;
      border-radius:1rem;
    }
  }
  &-detail.book &-li {
    .van-image {
      width:100%;
      height:53vw;
    }
  }
  &-swipe {
    width:90px;
    height:80px;
    text-align:center;
    .van-image{
      height:100%;
      border-radius:.5rem;
      overflow:hidden;
    }
    img {
      display: block;
    }
  }
  &-infos {
    .flex();
    flex-direction:column;
    padding-left:.9rem;
    flex-grow:1;
    min-width:0;
    justify-content:space-between;
  }
  &-title {
    .fontsize(1.1rem);
    .text-more();
    width:100%;
    line-height:1.45;
  }
  &-times {
    font-size:.85rem;
    color:#999;
  }
  &-status {
    .flex-center-v();
    justify-content:space-between;
  }
  &-prices {
    .flex-center-v();
    justify-content:space-between;
    justify-self:flex-end;
  }
  &-price {
    margin-top:.5rem;
    .fontsize(1.6rem);
    color:@orangecolor;
    small {
      padding-right:.25rem;
      font-size:65%;
    }
  }
  &-market {
    display:inline-block;
    .fontsize();
    color:#aaa;
    text-decoration:line-through;
    small {
      padding-right:.05rem;
    }
  }
  &-ops {
    margin-top:1rem;
    .flex-center-v();
    justify-content:space-between;
  }
  &-btns {
    .van-button {
      .fontsize(1.15rem);
    }
  }
  &-sales{
    text-align:right;
  }
  &-express {
    color: #999;
    padding: 5px 15px;
  }
  &-cell-group {
    margin: 15px 0;
    .van-cell__value {
      color: #999;
    }
  }
  &-tag {
    margin-left: 5px;
  }
}
.van-sticky--fixed .items-cate {
  margin-top:0;
  .shadow_black(0 5px 2px);
}
</style>